import React from "react";
import { useTranslation } from "react-i18next";
import IconChevronLeft from "../dynamicicons/icon-chevron-left";
import IconClose from "../dynamicicons/icon-close";
import * as styles from "./dropdown-panel-toolbar.module.scss";
import VelavuButton from "./velavu-button";
import VelavuIconButton from "./velavu-icon-button";
import IconMoreHorizontal from "../dynamicicons/icon-more-horizontal";
import whitelabel from "../whitelabel";

interface PanelToolbarProps {
	onBack?: VoidFunction;
	onDetail?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	detailOpen?: boolean;
	onClose?: VoidFunction;
}

export default function DropdownPanelToolbar(props: PanelToolbarProps) {
	const { t } = useTranslation();

	return (
		<div className={styles.navigation}>
			<VelavuButton
				label={t("common.back")}
				variant="outlined"
				icon={(size, color, className) => (
					<IconChevronLeft
						size={size}
						color={color}
						className={className}
					/>
				)}
				onClick={props.onBack}
			/>
			<div className={styles.actions}>
				{props.onDetail && (
					<VelavuIconButton
						onClick={props.onDetail}
						focus={props.detailOpen}
					>
						<IconMoreHorizontal
							color={whitelabel.palette.secondary500}
						/>
					</VelavuIconButton>
				)}

				<VelavuIconButton onClick={props.onClose}>
					<IconClose color={whitelabel.palette.secondary500} />
				</VelavuIconButton>
			</div>
		</div>
	);
}
